/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the ResetPasswordRequest interface.
 */
export function instanceOfResetPasswordRequest(value) {
    if (!('email' in value) || value['email'] === undefined)
        return false;
    return true;
}
export function ResetPasswordRequestFromJSON(json) {
    return ResetPasswordRequestFromJSONTyped(json, false);
}
export function ResetPasswordRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'email': json['email'],
    };
}
export function ResetPasswordRequestToJSON(json) {
    return ResetPasswordRequestToJSONTyped(json, false);
}
export function ResetPasswordRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'email': value['email'],
    };
}
